import { MultilingualLabel } from '@sparted/shared-library/business/types';

import { fetchFactory } from 'Libs/http/utils';

export const getCampaigns = async () => {
  const { fetchFn } = fetchFactory<{
    campaigns: { campaignId: number; title: MultilingualLabel; audienceId?: number }[];
  }>({
    route: '/api/campaigns',
    method: 'GET',
  });
  return fetchFn();
};
